import { render, staticRenderFns } from "./NotaRecurso-anterior.vue?vue&type=template&id=39e2bb0c&"
import script from "./NotaRecurso-anterior.vue?vue&type=script&lang=js&"
export * from "./NotaRecurso-anterior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports